module.exports = __webpack_public_path__ + "img/dollar-icon.b7c2fcf3.svg";